import { useRef } from 'react'
import { millisToTimeZoneMillis } from '../utils/dateFilterUtils'
import Box from '@/primitives/Box'
import Text from '@/primitives/Text'
import FlexV2 from '@/primitives/FlexV2'
import ReactDatePicker from 'react-datepicker'
import Symbol from '@/primitives/Symbol'

const getTimeZoneDate = (date, timeZone) =>
  millisToTimeZoneMillis(date, timeZone)

export function DatePicker({
  type,
  localFilter,
  onChangeFromDate,
  onChangeToDate,
  maxDate,
  strings,
  timeZone,
  dateFiltersSynced = false,
  isEnvironmental = false,
  ...restProps
}) {
  const ref = useRef(null)

  const isFromPicker = type === 'from'
  const onChange = isFromPicker ? onChangeFromDate : onChangeToDate
  const label = isFromPicker ? strings.startDateLabel : strings.endDateLabel
  const selectedDate = isFromPicker ? localFilter.fromDate : localFilter.toDate

  const selectedWithTZ = getTimeZoneDate(selectedDate, timeZone)
  const minDate = isFromPicker
    ? null
    : getTimeZoneDate(localFilter.fromDate, timeZone)

  const isDisabled = dateFiltersSynced && !isEnvironmental

  const adjustedMaxDate = maxDate
    ? millisToTimeZoneMillis(maxDate.toMillis(), timeZone)
    : undefined

  const onOpen = () => {
    if (ref.current && !isDisabled) {
      ref.current.setFocus(true)
    }
  }

  return (
    <Box>
      {label && (
        <Text variant='page' tone={600}>
          {label}
        </Text>
      )}
      <FlexV2
        alignCrossAxis='center'
        alignMainAxis='space-between'
        className='DateFilterDialog__DatePicker__Input'
        onClick={onOpen}
      >
        <ReactDatePicker
          ref={ref}
          showTimeSelect={true}
          timeFormat='HH:mm'
          timeIntervals={15}
          dateFormat='d MMM yyyy HH:mm'
          selected={selectedWithTZ}
          onChange={onChange}
          minDate={minDate}
          maxDate={adjustedMaxDate}
          disabled={isDisabled}
          {...restProps}
        />
        <Symbol name='calendar today' />
      </FlexV2>
    </Box>
  )
}
